import DTO from './DTO';

class CameraDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'id',
      },
      {
        name: 'name',
        type: String,
        validators: {},
        labelKey: 'camera.name',
      },
      {
        name: 'model',
        type: String,
        validators: {},
        labelKey: 'camera.model',
      },
      {
        name: 'type',
        type: String,
        validators: {},
        labelKey: 'camera.type',
      },
      {
        name: 'ip',
        type: String,
        validators: {},
        labelKey: 'ip',
      },
      {
        name: 'port',
        type: Number,
        validators: {},
        labelKey: 'port',
      },
      {
        name: 'username',
        type: String,
        validators: {},
        labelKey: 'login',
      },
      {
        name: 'password',
        type: String,
        validators: {},
        labelKey: 'password',
      },
      {
        name: 'password_confirmation',
        type: String,
        validators: {},
        labelKey: 'password.confirmation',
      },
      {
        name: 'longitude',
        type: Number,
        validators: {},
        labelKey: 'longitude',
      },
      {
        name: 'latitude',
        type: Number,
        validators: {},
        labelKey: 'latitude',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    const data = {
      id: this.id,
      name: this.name,
      ip: this.ip,
      port: this.port,
      username: this.username,
      password: this.password,
    };
    return data;
  }

  getCreateData() {
    const data = {
      name: this.name,
      ip: this.ip,
      port: this.port,
      username: this.username,
      password: this.password,
      latitude: this.latitude,
      longitude: this.longitude,
    };
    return data;
  }
}

export default CameraDTO;
